import React, { Component } from 'react';
import { ActivityIndicator, View, Text } from 'react-native';
import XDate from 'xdate';
import PropTypes from 'prop-types';
import styleConstructor from './style';
import { weekDayNames } from '../../dateutils';
import { withTheme } from '../../../../../theme';
class CalendarHeader extends Component {
    constructor(props) {
        super(props);
        this.getTextColor = idx => {
            const { theme } = this.props;
            if (idx < 6)
                return { color: theme.textSecondary };
            return { color: theme.textAlert };
        };
        this.style = styleConstructor(props.theme);
        this.addMonth = this.addMonth.bind(this);
        this.substractMonth = this.substractMonth.bind(this);
        this.onPressLeft = this.onPressLeft.bind(this);
        this.onPressRight = this.onPressRight.bind(this);
    }
    addMonth() {
        this.props.addMonth(1);
    }
    substractMonth() {
        this.props.addMonth(-1);
    }
    shouldComponentUpdate(nextProps) {
        if (nextProps.month.toString('yyyy MM') !== this.props.month.toString('yyyy MM')) {
            return true;
        }
        if (nextProps.showIndicator !== this.props.showIndicator) {
            return true;
        }
        if (nextProps.hideDayNames !== this.props.hideDayNames) {
            return true;
        }
        return false;
    }
    onPressLeft() {
        const { onPressArrowLeft } = this.props;
        if (typeof onPressArrowLeft === 'function') {
            return onPressArrowLeft(this.substractMonth);
        }
        return this.substractMonth();
    }
    onPressRight() {
        const { onPressArrowRight } = this.props;
        if (typeof onPressArrowRight === 'function') {
            return onPressArrowRight(this.addMonth);
        }
        return this.addMonth();
    }
    render() {
        const weekDaysNames = weekDayNames(this.props.firstDay);
        let indicator;
        if (this.props.showIndicator) {
            indicator = <ActivityIndicator color={this.props.theme && this.props.theme.indicatorColor}/>;
        }
        return (<View>
        <View style={this.style.header}>
          <View style={{ flexDirection: 'row' }}>
            <Text allowFontScaling={false} style={this.style.monthText} accessibilityTraits="header" accessibilityLabel="label_month">
              {this.props.month.toString(this.props.monthFormat)}
            </Text>
            {indicator}
          </View>
        </View>
        {!this.props.hideDayNames && (<View style={this.style.week}>
            {this.props.weekNumbers && <Text allowFontScaling={false} style={this.style.dayHeader}/>}
            {weekDaysNames.map((day, idx) => (<Text allowFontScaling={false} key={idx} accessible={false} style={[this.style.dayHeader, this.getTextColor(idx)]} numberOfLines={1} importantForAccessibility="no">
                {day}
              </Text>))}
          </View>)}
      </View>);
    }
}
CalendarHeader.propTypes = {
    theme: PropTypes.object,
    hideArrows: PropTypes.bool,
    month: PropTypes.instanceOf(XDate),
    addMonth: PropTypes.func,
    showIndicator: PropTypes.bool,
    firstDay: PropTypes.number,
    renderArrow: PropTypes.func,
    hideDayNames: PropTypes.bool,
    weekNumbers: PropTypes.bool,
    onPressArrowLeft: PropTypes.func,
    onPressArrowRight: PropTypes.func,
};
CalendarHeader.defaultProps = {
    monthFormat: 'MMMM yyyy',
};
export default withTheme(CalendarHeader);
